// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","tab":"tab--b64d1","no-tab":"no-tab--f8995","noTab":"no-tab--f8995"};